// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { PropTypes } from 'react';

// class name
import cx from 'classnames';


export default function ApplicationProgress(props) {
  let activeHit = false;
  let checkedIndex = 0;
  props.rowSubNav.forEach((subNav, index) =>
    (props.viewData[props.rowSubNav[index].key] || {}).done ? checkedIndex = index : null);

  return (
    <div className='application-progress-wrapper'>
        <ul
          className={`application-progress ${props.className}`}
        >
          {
            props.rowSubNav.map((subNav, index) => {
              // at present show checked until selected point (not holding "complete" state)
              const isActive = props.rowSubNav[index].key === props.activeRowSubNav;
              if(isActive) activeHit = true;

              // will change checked to be conditional on accordionData!!!
              return (
                <li
                  key={index}
                  data-id={subNav.display}
                  className={
                    cx('subnav-button',
                       {hide: subNav.display === 'Introduction'},
                       {active: isActive},
                       {bottomBorder: !activeHit || index < checkedIndex},
                       {highlightedCircleEdge: !activeHit || isActive || index <= checkedIndex},
                       {checked: (props.viewData[props.rowSubNav[index].key] || {}).done})
                    }
                  onClick={props.updateRowSubNav.bind(this, subNav.key)}
                >
                  <div className='subnav-text-container'>
                    <span className='subnav-text'>
                      {subNav.display}
                    </span>
                  </div>
                </li>
              );
            })
          }
        </ul>
    </div>
  );
}

ApplicationProgress.propTypes = {
  updateRowSubNav: PropTypes.func,
  activeRowSubNav: PropTypes.string,
  adjustProgressView: PropTypes.number,
  rowSubNav: PropTypes.array,
  viewData: PropTypes.object,
  className: PropTypes.string
};



// WEBPACK FOOTER //
// ./shared/react/r_ApplicantDashboard/f_Application/f_ApplicationProgress/index.js